import React from 'react';

import { getRouteApi } from '@tanstack/react-router';
import { LOAN_REQUEST_COMMANDS } from 'cpool-constants';
import { useTranslation } from 'react-i18next';

import TitleCurrencyInput from '~/features/leadDetails/components/Overview/CustomerData/Employment/inputs/general/TitleCurrencyInput.tsx';
import { FormCard } from '~/features/leadDetails/components/Overview/CustomerData/shared/FormCard';
import { useAclPermissions } from '~/features/leadDetails/hooks/useAclPermissions';
import { canExecuteApplicantCommand } from '~/features/leadDetails/utils/aclPermissions';

const Unemployed: React.FC<{ secondApplicant?: boolean }> = ({ secondApplicant }) => {
    const { leadId } = getRouteApi('/_app/leads_/details/$leadId').useParams();
    const { permissions } = useAclPermissions({ loanRequestId: leadId });
    const { t } = useTranslation();
    const employmentTranslationPath = 'CREDIT_WORTHINESS.SECTIONS.EMPLOYMENT';
    const incomeTranslationPath = 'CREDIT_WORTHINESS.SECTIONS.INCOME';

    const paths = {
        otherIncome: 'beschaeftigung.arbeitsloser.sonstigesEinkommenMonatlich',
    };

    const isDisabled = !canExecuteApplicantCommand({
        applicant: secondApplicant ? 2 : 1,
        commandName: LOAN_REQUEST_COMMANDS.changeApplicantEmployment,
        permissions,
    });

    return (
        <>
            <FormCard
                data-testid={'unemployed-sub-form'}
                title={t(`${employmentTranslationPath}.SUBSECTIONS.INCOME_HEALTH_INSURANCE`)}
            >
                <TitleCurrencyInput
                    title={t(`${incomeTranslationPath}.OTHER_INCOME`)}
                    name={paths.otherIncome}
                    disabled={isDisabled}
                />
            </FormCard>
        </>
    );
};

export default Unemployed;
